import { trackEvent } from './segment';

export const trackPackageProjectStarted = ({
  budgetAnswer,
  designStyleAnswer,
  finishAnswer,
  reasonForDesign,
  spaceSelected,
  userId
}) => {
  trackEvent({
    event: 'package_project_started',
    properties: {
      budget_answer: budgetAnswer,
      design_style_answer: designStyleAnswer,
      finish_answer: finishAnswer,
      reason_for_design: reasonForDesign,
      space_selected: spaceSelected,
      user_id: userId
    }
  });
};

export const trackPackageCouponApplied = ({
  couponAmount,
  couponText,
  packageType,
  userId
}) => {
  trackEvent({
    event: 'package_coupon_applied',
    properties: {
      coupon_amount: couponAmount,
      coupon_text: couponText,
      package_type: packageType,
      user_id: userId
    }
  });
};

export const trackPackageOrderComplete = ({
  designfeedParams,
  directToCheckout,
  orderNumber,
  packageType,
  paymentTotal,
  spaceId,
  userId
}) => {
  trackEvent({
    event: 'package_order_complete',
    properties: {
      designfeed_params: designfeedParams,
      direct_to_checkout: directToCheckout,
      order_number: orderNumber,
      package_type: packageType,
      payment_total: paymentTotal,
      space_id: spaceId,
      user_id: userId
    }
  });
};
